import Cookies from 'js-cookie'
import { useCallback, useEffect, useMemo, useState } from 'react'

import { PROMO_HIDDEN_COOKIE_VALUE } from '../PromotionsBar.constants'
import { getPromotionsBarCookieName } from '../PromotionsBar.utils'

export const usePromotionsBarCookie = ({
  isPromoBarHidden: defaultPromoBarHidden,
  content,
}: {
  isPromoBarHidden?: boolean
  content: string
}) => {
  const cookieName = useMemo(() => getPromotionsBarCookieName(content), [content])

  const [isPromoBarHidden, setPromoHiddenInCookie] = useState(
    () => defaultPromoBarHidden ?? Cookies.get(cookieName) === PROMO_HIDDEN_COOKIE_VALUE,
  )

  useEffect(() => {
    setPromoHiddenInCookie(Cookies.get(cookieName) === PROMO_HIDDEN_COOKIE_VALUE)
  }, [cookieName])

  const hidePromoBar = useCallback(() => {
    Cookies.set(cookieName, PROMO_HIDDEN_COOKIE_VALUE)
    setPromoHiddenInCookie(true)
  }, [cookieName])

  return {
    isPromoBarHidden,
    hidePromoBar,
  }
}
